import { GetStaticPaths, GetStaticProps } from "next";
import { FunctionComponent } from "react";
import { CafesPageBaseProps } from "../../../../lib/sanity/shared";
import {
  getDefaultStaticPaths,
  getDefaultStaticPropsCafesPage,
} from "../../../../lib/utils";
import { CafeSearch } from "../../../../components/CafeSearch/CafeSearch";
import { LayoutWrapper } from "../../../../components/LayoutWrapper";
import {
  DereferencedCafeLocator,
  toCafeSearchProps,
} from "../../../../lib/transformers/cafe-locator";
import { CafesPageData } from ".";
import { useDoordashButton } from "../../../../lib/integrations/doordash/use-doordash-button";

export const getStaticPaths: GetStaticPaths = getDefaultStaticPaths;

export const getStaticProps: GetStaticProps<CafesPageBaseProps> = async (
  context,
) => {
  const { props: defaultProps } = await getDefaultStaticPropsCafesPage(context);

  return {
    props: {
      ...defaultProps,
    },
  };
};

const CafeSearchResultsPage: FunctionComponent<CafesPageData> = ({
  ...layoutWrapperProps
}) => {
  const { aria, cafesPage, lang, region } = layoutWrapperProps;
  const module = cafesPage.modules?.filter(
    (mod) => mod._type === "cafeLocator",
  );
  const cafeLocator = module?.[0] as DereferencedCafeLocator;

  useDoordashButton();

  return (
    <LayoutWrapper
      {...{
        ...layoutWrapperProps,
        pageTitle: cafeLocator
          ? cafeLocator.copy.headline[lang]
          : "Cafe Locator | Blue Bottle Coffee",
      }}
    >
      {cafeLocator && (
        <CafeSearch
          {...toCafeSearchProps({
            data: cafeLocator,
            isModule: false,
            lang,
            region,
          })}
          ariaCopy={aria}
        />
      )}
    </LayoutWrapper>
  );
};

export default CafeSearchResultsPage;
